import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

import zhTWMessages from 'assets/locale/zh-TW.json';
import enUSMessages from 'assets/locale/en-US.json';
import jaMessages from 'assets/locale/ja.json';

const messages = {
    'zh-TW': zhTWMessages,
    'en-US': enUSMessages,
    ja: jaMessages
};

function mapStateToProps(state) {
    const { locale } = state.i18n;
    return { locale, messages: messages[locale] || {} };
}

export default connect(mapStateToProps)(IntlProvider);
